import { RedirectProps, RouteProps } from 'react-router';

import PricingPage from '../../views/pages/Pricing/Pricing';
import Register from '../../views/pages/Register/Register';
import RegistrationError from '../../views/pages/RegistrationError';
import EmailSent from '../../views/pages/EmailSent';
import EmailConfirmed from '../../views/pages/EmailConfirmed';
import EmailConfirmationError from '../../views/pages/EmailConfirmationError';
import LogIn from '../../views/pages/LogIn';
import Landing from '../../views/pages/Landing';
import PasswordRecovery from '../../views/pages/password-recovery/PasswordRecovery';
import PasswordResetEmailSent from '../../views/pages/password-recovery/EmailSent';
import PasswordRecoveryError from '../../views/pages/password-recovery/PasswordRecoveryError';
import PasswordReset from '../../views/pages/password-recovery/PasswordReset';
import PasswordResetSuccess from '../../views/pages/password-recovery/PasswordResetSuccess';
import InvitationPage from '../../views/pages/invitation/InvitationPage';

export const pricing = {
  path: '/pages/pricing',
  component: PricingPage,
} as RouteProps;

export const register = {
  path: '/pages/register',
  component: Register,
} as RouteProps;

export const registrationError = {
  path: '/pages/register-error',
  component: RegistrationError,
} as RouteProps;

export const emailSent = {
  path: '/pages/email-sent',
  component: EmailSent,
} as RouteProps;

export const emailConfirmed = {
  path: '/pages/email-confirmation',
  component: EmailConfirmed,
} as RouteProps;

export const emailError = {
  path: '/pages/email-confirmation-error',
  component: EmailConfirmationError,
} as RouteProps;

export const login = {
  path: '/pages/login',
  component: LogIn,
} as RouteProps;

export const home = {
  path: '/',
  component: Landing,
} as RouteProps;

export const pages = {
  from: '/pages',
  to: '/',
} as RedirectProps;

export const passwordRecovery = {
  path: '/pages/password-recover',
  component: PasswordRecovery,
} as RouteProps;

export const passwordRecoverEmailSent = {
  path: '/pages/password-recover-email-sent',
  component: PasswordResetEmailSent,
} as RouteProps;

export const passwordRecoveryError = {
  path: '/pages/password-recover-error',
  component: PasswordRecoveryError,
} as RouteProps;

export const passwordReset = {
  path: '/pages/password-recover-change',
  component: PasswordReset,
} as RouteProps;

export const passwordResetSuccess = {
  path: '/pages/password-recover-success',
  component: PasswordResetSuccess,
} as RouteProps;

export const invitationPage = {
  path: '/pages/accept-invitation',
  component: InvitationPage,
} as RouteProps;

export default [
  pricing,
  register,
  registrationError,
  emailSent,
  emailConfirmed,
  emailError,
  login,
  passwordRecovery,
  passwordRecoverEmailSent,
  passwordRecoveryError,
  passwordReset,
  passwordResetSuccess,
  invitationPage,
  home,
  pages,
] as const;
